module.exports = {
      id: "pre-blue-playgrounds-usage",
      viewBox: "0 0 36 44",
      url: __webpack_public_path__ + "sprite-d2a4e8aaeb47684d6d07571fc646b0db.svg#pre-blue-playgrounds",
      toString: function () {
        return this.url;
      }
    }